import AlertBar from './AlertBar.jsx';
import React from 'react';
import PropTypes from 'prop-types';
import alerter from './Alerter.js';
import ScrollIntoView from '../ScrollIntoView.jsx';

class AlertArea extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alerts: []
    };
  }

  componentDidMount() {
    let unsubAlert = alerter.onAlert(alert => this.showAlert(alert));
    let unsubDismiss = alerter.onDismiss(dismiss => this.dismissAlert(dismiss));
    this.unsubscribe = () => {
      unsubAlert();
      unsubDismiss();
    };
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  showAlert(alert) {
    let { channels } = this.props;
    if (!channels) {
      channels = [];
    }
    else if (typeof channels === 'string') {
      channels = channels.split(/\s+/);
    }
    channels = channels.map(c => c.trim());
    if ((channels.length === 0 && !alert.channel) || channels.find(c => alert.channel && c === alert.channel.trim())) {
      let alerts = this.state.alerts.slice();
      alerts.push(alert);
      this.setState({ alerts });
    }
  }

  dismissAlert({id}) {
    const alerts = this.state.alerts.filter(alert => id && alert.id !== id);
    this.setState({ alerts });
  }

  translateAlertType(type) {
    if (type === 'danger') {
      console.error(`Deprecated type: ${type}. Type replaced with: error.`);
      return 'error';
    }

    return type;
  }

  render() {
    let {
      scrollIntoView,
    } = this.props;

    return (
      <div>
        {
          this.state.alerts.map(({
            id,
            message,
            type,
            ...other
          }) => {
            const alertType = this.translateAlertType(type);
            let result = (
              <AlertBar
                key={id}
                alertType={alertType}
                {...other}
              >
                {message}
              </AlertBar>
            );

            if (scrollIntoView) {
              result = (
                <ScrollIntoView
                  key={id}
                >
                  {result}
                </ScrollIntoView>
              );
            }

            return result;
          })
        }
      </div>
    );
  }
}

AlertArea.propTypes = {
  channels: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  scrollIntoView: PropTypes.bool,
};

AlertArea.defaultProps = {
  scrollIntoView: false,
};

export default AlertArea;